import { ITabConfig } from '../../../interface/ITab';
import { makeElement } from '../../../common/Utils';
import { findActiveHref } from '../../util';
import {
    PARENT_DEPTH,
    TAB_SWIPE_CLASS,
    TAB_WRAP_CLASS,
    TAB_LIST_CLASS,
    TAB_LIST_ITEMS_CLASS,
    ACTIVE_ITEMS_CLASS,
} from '../../constant';
import DepthTabEvent from './DepthTabEvent';

export default class DepthTabLayer {
    private config: ITabConfig;
    private $rootHtml: HTMLDivElement | null = null;
    private pathArr: number[] = [];
    private isFindPath: boolean = false;

    constructor(_config: ITabConfig) {
        this.config = _config;
        this.setRootHTML();
        this.pathArr = this.findActiveTab(this.config.parent, []);
        this.renderTabs();
        new DepthTabEvent(_config);
    }
    private setRootHTML(): void {
        this.$rootHtml = document.querySelector(
            `.${this.config.rootHTMLClass || 'tab-wrap-contents'}`
        );
        if (!this.$rootHtml) return;
        this.$rootHtml.innerHTML = '';
    }
    // 활성화된 탭 찾기
    // ex) [0, 1, 0]: 뎁스1의 0번째, 뎁스2의 1번째, 뎁스3의 0번째
    private findActiveTab(
        data: ITabConfig['parent'],
        parentIndices: number[]
    ): number[] {
        let parentIndicesOfNodeWithHref = [0]; // 만약에 활성화된 탭이 없을 경우 최상위 뎁스만 활성화하기 위함
        for (let i = 0; i < data.length; i++) {
            const newParentIndices = [...parentIndices, i];
            if (
                findActiveHref(
                    data[i].href,
                    location.pathname,
                    data[i].compareArr
                )
            ) {
                parentIndicesOfNodeWithHref = newParentIndices;
                this.isFindPath = true;
                break;
            }

            if (data[i].children) {
                const result = this.findActiveTab(
                    data[i].children,
                    newParentIndices
                );
                if (result) parentIndicesOfNodeWithHref = result;
            }
        }
        return parentIndicesOfNodeWithHref;
    }
    // 활성화된 탭만 그리기
    private renderTabs(): void {
        let tabData = this.config.parent;
        this.pathArr.forEach((activeIndex, i) => {
            const $depthParent = this.appendDepthWrapperInRoot(
                this.$rootHtml!,
                PARENT_DEPTH + i
            );
            this.renderTabList(
                $depthParent,
                tabData,
                this.isFindPath ? activeIndex : -1
            );
            tabData = tabData[activeIndex]?.children;
        });
    }
    private appendDepthWrapperInRoot = (
        $rootHtml: HTMLDivElement,
        depthLevel: number
    ): HTMLDivElement => {
        const $depthParent = makeElement(
            `<div class="${TAB_SWIPE_CLASS}${
                depthLevel === PARENT_DEPTH ? ' parent-tab' : ''
            }" data-depth="${depthLevel}"></div>`
        ) as HTMLDivElement;
        $rootHtml.insertAdjacentElement('beforeend', $depthParent);
        return $depthParent;
    };
    private renderTabList = (
        $targetHtml: HTMLDivElement,
        tabItemData: ITabConfig['parent'],
        activeIndex: number
    ): string => {
        const depthWrapperTemplate = `
                <div class="${TAB_WRAP_CLASS}">
                    <ul class="${TAB_LIST_CLASS}">
                        ${this._renderTabItems(tabItemData, activeIndex)}
                    </ul>
                </div>
        `;
        $targetHtml.insertAdjacentHTML('beforeend', depthWrapperTemplate);
        return depthWrapperTemplate;
    };
    private _renderTabItems(
        tabItemData: ITabConfig['parent'],
        activeIndex: number
    ): string {
        return tabItemData
            .map((tabItem, index) => {
                return `
                <li class="${TAB_LIST_ITEMS_CLASS}${
                    activeIndex === index ? ` ${ACTIVE_ITEMS_CLASS}` : ''
                }">
                    <a
                        href="${tabItem.href || '/'}"
                        target="${tabItem.isBlank ? '_blank' : '_self'}"
                    >${
                        !!tabItem.img
                            ? `<img src="${tabItem.img}" class="img-pc" alt="${tabItem.name}">
                            <img src="${tabItem.img_m}" class="img-m" alt="${tabItem.name}">`
                            : tabItem.name
                    }</a>
                </li>
            `;
            })
            .join('');
    }
}
